import { FC } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import dayjs from 'dayjs';
import { CustomDatePickerFormik, CustomSelectFormik } from 'components/elements';
import { shouldDisableMonth, disablePastYear } from 'pages/OtherReceiptsPage/config';
import { IServicePaymentFilters } from 'types';
import { SERVICE_PAYMENTS_STATUS_OPTIONS } from 'utils/constants';
import { DATE_FORMAT } from 'utils/enums';
import { DEFAULT_SERVICE_PAYMENT_FILTERS } from '../config';
import { ServiceAutocomplete } from './ServiceAutocomplete';
import { ProviderSelect } from './ProviderSelect';
import s from './index.module.scss';

interface ServicePaymentsFiltersProps {
	initialValues: IServicePaymentFilters;
	isExportCsvLoading: boolean;
	onExportCsv: (values: IServicePaymentFilters) => void;
	onSubmitFilters: (values: IServicePaymentFilters) => void;
	onResetFilters: (values: IServicePaymentFilters) => void;
}

export const ServicePaymentsFilters: FC<ServicePaymentsFiltersProps> = ({
	initialValues,
	isExportCsvLoading,
	onExportCsv,
	onSubmitFilters,
	onResetFilters,
}) => {
	const handleResetFilters = (filters: IServicePaymentFilters) => {
		onResetFilters(filters);
	};

	return (
		<Formik initialValues={initialValues} onSubmit={onSubmitFilters}>
			{({ values, setFieldValue, setValues }) => (
				<Form className={s.filter}>
					<Box className={s.row}>
						<Box className={s.date__filters}>
							<Field
								name="gte"
								views={['year', 'month', 'day']}
								format={DATE_FORMAT.DAY_MONTH_NAME_YEAR}
								shouldDisableMonth={shouldDisableMonth}
								shouldDisableYear={disablePastYear}
								className={s.date__input}
								component={CustomDatePickerFormik}
							/>
							<span>-</span>
							<Field
								name="lte"
								views={['year', 'month', 'day']}
								format={DATE_FORMAT.DAY_MONTH_NAME_YEAR}
								shouldDisableMonth={shouldDisableMonth}
								shouldDisableYear={disablePastYear}
								className={s.date__input}
								component={CustomDatePickerFormik}
							/>
						</Box>
						<ServiceAutocomplete
							servicesValue={values.services}
							onChange={(value) => setFieldValue('services', value)}
						/>
						<ProviderSelect />
						<Field
							className={s.select}
							name="status"
							placeholder="Статус"
							options={SERVICE_PAYMENTS_STATUS_OPTIONS}
							component={CustomSelectFormik}
							multiple
						/>
						<Button
							disabled={isExportCsvLoading}
							variant="contained"
							type="button"
							onClick={() => onExportCsv(values)}
						>
							Завантажити CSV
						</Button>
					</Box>
					<Box className={s.row}>
						<Box className={s.amount}>
							<Typography>Сума</Typography>
							<Field label="Від" name="amountFrom" placeholder="123.50" variant="outlined" as={TextField} />
							<Field label="До" name="amountTo" variant="outlined" placeholder="321.50" as={TextField} />
						</Box>
						{/* <Field className={s.input} label="Id партнера" name="providerId" variant="outlined" as={TextField} /> */}
						<Field className={s.input} label="Id сервісу" name="serviceId" variant="outlined" as={TextField} />
						<Field className={s.input} label="Id пакету" name="mainBillId" variant="outlined" as={TextField} />
						<Button variant="contained" type="submit">
							Застосувати
						</Button>
						<Button
							variant="outlined"
							onClick={() => {
								const filters = {
									...DEFAULT_SERVICE_PAYMENT_FILTERS,
									gte: dayjs().subtract(30, 'day'),
									lte: dayjs(),
								};
								setValues(filters);
								handleResetFilters({ ...filters, searchQuery: '' });
							}}
						>
							Очистити
						</Button>
					</Box>
				</Form>
			)}
		</Formik>
	);
};
